import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungTrier() {
  return (
    <CityPageTemplate
      city="Trier"
      slug="trier"
      intro="Trier als älteste Stadt Deutschlands – Deine Finanzen sollten genauso beständig und solide sein."
      description="Unabhängige & digitale Finanzberatung für Trier: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
